<div class="alert alert-danger" *ngIf="entity?.warns?.length > 0">
  <h5>Inconsistências: </h5>
  <ol>
    <li *ngFor="let warning of entity?.warns">{{ warning?.warn_msg }}</li>
  </ol>
</div>

<form [formGroup]="form">
  <div *ngIf="entity?.questions?.length">
    <div formArrayName="questions">
      <div *ngFor="let item of entity?.questions let i = index" [formGroupName]="0">

        <h3 *ngIf="shouldShowHeader(item.tab_group_name, i)" class="mt-4 mb-3">{{item?.tab_group_name}}</h3>

        <div class="form-group row m-b" *ngIf="item?.type_id == entity?.ppQuestion['TYPE_TEXTO']" [formGroupName]="item?.question_id">
          <div class="col-xxl-8 col-lg-10 col-sm-12">
            <label class="col-sm-12 pb-1">
              <span *ngIf="!item?.ref_link; else itemLink">{{ item?.title }}</span>
              <ng-template #itemLink>
                <a [href]="item?.ref_link" target="_blank" rel="noopener noreferrer">{{ item?.title }}</a>
              </ng-template>
              <i class="pl-1 fa fa-info-circle icon" placement="right" *ngIf="item?.tooltip" [tooltip]="item?.tooltip"></i>
            </label>
            <textarea class="form-control" formControlName="ds_value" rows="4" [maxlength]="item?.max_length"></textarea>
            <app-field-message [field]="fieldMessageRequireds(item?.question_id)" [erros]="fieldErrosFormArray(item?.question_id)"></app-field-message>
          </div>
        </div>

        <div class="form-group row m-b" *ngIf="item?.type_id == entity?.ppQuestion['TYPE_NUMERICO']" [formGroupName]="item?.question_id">
          <div class="col-xxl-8 col-lg-10 col-sm-12">
            <label class="col-sm-12 pb-1">
              <span *ngIf="!item?.ref_link; else itemLink">{{ item?.title }}</span>
              <ng-template #itemLink>
                <a [href]="item?.ref_link" target="_blank" rel="noopener noreferrer">{{ item?.title }}</a>
              </ng-template>
              <i class="pl-1 fa fa-info-circle icon" placement="right" *ngIf="item?.tooltip" [tooltip]="item?.tooltip"></i>
            </label>
            <input id="filter_cost_total1" class="form-control text-right" formControlName="ds_value" (keyup)="formatarMedidaFisica2(item?.question_id, item?.dec_places !== null ? item?.dec_places : 4)">
            <app-field-message [field]="fieldMessageRequireds(item?.question_id)" [erros]="fieldErrosFormArray(item?.question_id)"></app-field-message>
          </div>
        </div>

        <div class="form-group row m-b" *ngIf="item?.type_id == entity?.ppQuestion['TYPE_DATA']" [formGroupName]="item?.question_id">
          <div class="col-xxl-8 col-lg-10 col-sm-12">
            <label class="col-sm-12 pb-1">
              <span *ngIf="!item?.ref_link; else itemLink">{{ item?.title }}</span>
              <ng-template #itemLink>
                <a [href]="item?.ref_link" target="_blank" rel="noopener noreferrer">{{ item?.title }}</a>
              </ng-template>
              <i class="pl-1 fa fa-info-circle icon" placement="right" *ngIf="item?.tooltip" [tooltip]="item?.tooltip"></i>
            </label>
            <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="ds_value" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }" placeholder="dd/mm/aaaa" (keyup)="clearInput($event)">
            <app-field-message [field]="fieldMessageRequireds(item?.question_id)" [erros]="fieldErrosFormArray(item?.question_id)"></app-field-message>
          </div>
        </div>

        <div class="form-group row m-b" *ngIf="item?.type_id == entity?.ppQuestion['TYPE_COMBO']" [formGroupName]="item?.question_id">
          <div class="col-xxl-8 col-lg-10 col-sm-12">
            <label class="col-sm-12 pb-1">
              <span *ngIf="!item?.ref_link; else itemLink">{{ item?.title }}</span>
              <ng-template #itemLink>
                <a [href]="item?.ref_link" target="_blank" rel="noopener noreferrer">{{ item?.title }}</a>
              </ng-template>
              <i class="pl-1 fa fa-info-circle icon" placement="right" *ngIf="item?.tooltip" [tooltip]="item?.tooltip"></i>
            </label>
            <ng-select id="filter_corede_ben" class="ng-select-alternative" [items]="item?.questionList" [multiple]="true" bindLabel="ds_value" bindValue="ds_value" placeholder="Todos" formControlName="ds_value">
            </ng-select>
            <app-field-message [field]="fieldMessageRequireds(item?.question_id)" [erros]="fieldErrosFormArray(item?.question_id)"></app-field-message>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end">
    <div class="col-xxl-8 col-lg-10 col-sm-12 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-danger m-r-xxl" *ngIf="entity?.id && entity?.can_delete" (click)="confirmExcluir()" type="button">Excluir</button>
      <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
      <button class="btn btn-white m-r-xs" *ngIf="entity?.id" type="button" (click)="imprimir()">Imprimir</button>
      <button class="btn btn-white m-r-xs" *ngIf="entity?.id && entity?.can_clone" type="button" (click)="openCloneModal()">Clonar</button>
      <button class="btn btn-primary" *ngIf="entity?.id && entity?.can_save" (click)="update()">Salvar</button>
    </div>
  </div>
</form>

<app-historico-atualizacoes-list *ngIf="entity?.id" [audit]="audit"></app-historico-atualizacoes-list>
<app-loading [loader]="isLoading"></app-loading>

<ng-template #modalClone>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Clonar processo</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeCloneModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body table-form">
    <div class="form-group row">
      <div class="col-sm-12 m-b">
        <label class="col-sm-12 pb-1">Novo Nome</label>
        <input class="form-control" [(ngModel)]="clone_title" maxlength="300">
      </div>
    </div>
    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-xxl-8 col-lg-10 col-sm-12 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-white m-r-xs" type="button" (click)="closeCloneModal()">Fechar</button>
        <button class="btn btn-primary" type="button" [disabled]="!clone_title" (click)="clonar()">Clonar</button>
      </div>
    </div>
  </div>
</ng-template>